import { render, staticRenderFns } from "./CRUDAtendimentoConfig.vue?vue&type=template&id=04be5fda&"
import script from "./CRUDAtendimentoConfig.vue?vue&type=script&lang=js&"
export * from "./CRUDAtendimentoConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports